import React, { useEffect, useState } from 'react'
import userlogo from '../../assets/images/profile.png'
import { Accordion, Offcanvas } from 'react-bootstrap'
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { NavLink } from 'react-router-dom';
import { MdDashboard, MdMarkChatUnread, MdOutlinePayment } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { MessageSquareDot } from 'lucide-react'


import { FaGlobe, FaLink, FaUserCheck } from 'react-icons/fa';
import Footer from './Footer';

export default function Sidebar({ show, handleClose }) {
    const location = window.location.pathname;

    // Helper to safely get items from localStorage
    const getStorageItem = (key) => {
        const item = localStorage.getItem(key);
        return item && item !== 'undefined' && item !== 'null' ? item : null;
    };

    // Initialize state from localStorage
    const [profilePhoto, setProfilePhoto] = useState(getStorageItem('profile_photo'));
    const [title, setTitle] = useState(getStorageItem('title'));
    const [name, setName] = useState(getStorageItem('name'));

    useEffect(() => {
        // Function to update state from localStorage
        const handleUserDataUpdate = () => {
            setProfilePhoto(getStorageItem('profile_photo'));
            setTitle(getStorageItem('title'));
            setName(getStorageItem('name'));
        };

        // Listen for the custom event
        window.addEventListener('userDataUpdated', handleUserDataUpdate);

        // Also listen for storage events (for cross-tab updates, though not strictly required for this task)
        window.addEventListener('storage', handleUserDataUpdate);

        return () => {
            window.removeEventListener('userDataUpdated', handleUserDataUpdate);
            window.removeEventListener('storage', handleUserDataUpdate);
        };
    }, []);

    const SidebarContent = () => (
        <>
            <div className="profile-header">
                <div className='text-center sidebar-logo-section'>
                    <div className='user_img_section text-center mx-auto'>
                        <img src={
                            profilePhoto ? process.env.REACT_APP_BASE_URL + profilePhoto : userlogo} alt="img" className='img-fluid user-img2' />
                    </div>
                    <h5 className='mt-2 text-capitalize'>{name} </h5>
                </div>
            </div>
            <hr className='m-0' />
            <div className="offcanvas-body profile-sidebar-body">
                <PerfectScrollbar>
                    <Accordion>
                        <Accordion.Item className={location == '/dashboard' ? 'acc_btn_active' : 'acc_btn'} eventKey="0">
                            <NavLink to="../dashboard" onClick={handleClose}>
                                <Accordion.Header>
                                    <MdDashboard className=' me-2' size={20} /> Dashboard
                                </Accordion.Header>
                            </NavLink>
                        </Accordion.Item>
                    </Accordion>
                    <Accordion>
                        <Accordion.Item className={location == '/bio-page' ? 'acc_btn_active' : 'acc_btn'} eventKey="0">
                            <NavLink to="../bio-page" onClick={handleClose}>
                                <Accordion.Header>
                                    <FaGlobe className=' me-2' size={20} /> Bio Page
                                </Accordion.Header>
                            </NavLink>
                        </Accordion.Item>
                    </Accordion>
                    <Accordion>
                        <Accordion.Item className={location == '/short-links' ? 'acc_btn_active' : 'acc_btn'} eventKey="0">
                            <NavLink to="../short-links" onClick={handleClose}>
                                <Accordion.Header>
                                    <FaLink className=' me-2' size={20} /> Short Links
                                </Accordion.Header>
                            </NavLink>
                        </Accordion.Item>
                    </Accordion>
                    <Accordion>
                        <Accordion.Item className={location == '/connection-management' ? 'acc_btn_active' : 'acc_btn'} eventKey="0">
                            <NavLink to="../connection-management" onClick={handleClose}>
                                <Accordion.Header>
                                    <FaUserCheck className=' me-2' size={20} /> Connection
                                </Accordion.Header>
                            </NavLink>
                        </Accordion.Item>
                    </Accordion>
                    <Accordion>
                        <Accordion.Item className={location == '/chat-list' ? 'acc_btn_active' : 'acc_btn'} eventKey="0">
                            <NavLink to="../chat-list" onClick={handleClose}>
                                <Accordion.Header>
                                    <MdMarkChatUnread className=' me-2' size={20} /> Chat List
                                </Accordion.Header>
                            </NavLink>
                        </Accordion.Item>
                    </Accordion>
                    <Accordion>
                        <Accordion.Item className={location == '/payment-history' ? 'acc_btn_active' : 'acc_btn'} eventKey="0">
                            <NavLink to="../payment-history" onClick={handleClose}>
                                <Accordion.Header>
                                    <MdOutlinePayment className=' me-2' size={20} /> Payment History
                                </Accordion.Header>
                            </NavLink>
                        </Accordion.Item>
                    </Accordion>
                </PerfectScrollbar>
            </div>

        </>
    );

    return (
        <>
            {/* Desktop Sidebar */}
            <div className="sidebar-desktop">
                <SidebarContent />
            </div>

            {/* Mobile/Tablet Offcanvas */}
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="start"
                className="sidebar-offcanvas"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0">
                    <SidebarContent />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}
